import React from 'react';

const ConfirmRow = ({children, title, bodyAlignCenter = true, isPrimaryHeader = true}) => {
  bodyAlignCenter = false;
  const headClass = (isPrimaryHeader ? 'col-12' : 'col-4')
    + " col-md-2 d-flex align-items-center"
    + (isPrimaryHeader ? ' mb-2 mb-md-0' : '');
  const bodyClass = (isPrimaryHeader ? 'col-12' : 'col-8') + " col-md-10" + (bodyAlignCenter ? ' d-flex align-items-center' : '');
  return (
    <div className="row">
      <div className={headClass}>
        { title }
      </div>
      <div className={bodyClass} >
        { children }
      </div>
    </div>
  )
};

export default ConfirmRow;
